import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';

export const paragraph: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}

  &:first-of-type {
    margin-top: 0;
  }
`;
